import { motion } from "framer-motion";
import React from "react";
import "./hero-floating-icons.scss";
const HeroFloatingIcons = ({ image, text1, text2, className, variants }) => {
  return (
    // <div className="hero-floating-icons">
    <motion.div
      variants={variants}
      className={`hero-floating-icons ${className}`}
    >
      <img src={image} alt="floating_icon" style={{ marginLeft: "-0.6rem" }} />
      <span>
        {text1}
        <br />
        {text2}
      </span>
    </motion.div>
  );
};

export default HeroFloatingIcons;
